import { configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';

let store;
if (import.meta.env.DEV) {
  store = configureStore({
    reducer: reducers,
    devTools: {
      trace: true,
      traceLimit: 25,
    },
  });
} else {
  store = configureStore({ reducer: reducers });
}

export default store;
